import { render, staticRenderFns } from "./LeftSideBarBottom.vue?vue&type=template&id=5b0cf7ec&scoped=true&"
import script from "./LeftSideBarBottom.vue?vue&type=script&lang=js&"
export * from "./LeftSideBarBottom.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideBarBottom.vue?vue&type=style&index=0&id=5b0cf7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0cf7ec",
  null
  
)

export default component.exports